export default "__VITE_ASSET__BQP29I4I__"